export const GET_SINGLE_SHARE_EXPERIENCE = "GET_SINGLE_SHARE_EXPERIENCE";
export const RESET_SINGLE_SHARE_EXPERIENCE = "RESET_SINGLE_SHARE_EXPERIENCE";
export const SET_SINGLE_SHARE_EXPERIENCE_REQUEST_STATUS = "SET_SINGLE_SHARE_EXPERIENCE_REQUEST_STATUS";
